import { QueryClient } from "@tanstack/react-query";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: 1,
    },
  },
});

// ── Query key factories ──

export const itemKeys = {
  all: ["items"] as const,
  list: (filters: { search?: string; status?: string }) => ["items", "list", filters] as const,
  detail: (id: string) => ["items", "detail", id] as const,
};

export const userKeys = {
  all: ["users"] as const,
  list: (filters?: { search?: string }) => ["users", "list", filters] as const,
} as const;

export const projectKeys = {
  all: ["projects"] as const,
  list: (filters: { search?: string; status?: string }) => ["projects", "list", filters] as const,
  detail: (id: string) => ["projects", "detail", id] as const,
} as const;

export const devKeys = {
  seedAccounts: ["dev", "seed-accounts"] as const,
} as const;

export const templateKeys = {
  all: ["templates"] as const,
  list: (filters?: { status?: string }) => ["templates", "list", filters] as const,
  detail: (id: string) => ["templates", "detail", id] as const,
};

export const auditKeys = {
  all: ["audits"] as const,
  list: (filters?: { status?: string }) => ["audits", "list", filters] as const,
  detail: (id: string) => ["audits", "detail", id] as const,
  itemNotes: (auditId: string, itemId: string) =>
    ["audits", "item-notes", auditId, itemId] as const,
  files: (auditId: string) => ["audits", "files", auditId] as const,
};

export const complianceUserKeys = {
  all: ["compliance-users"] as const,
};

export const reportKeys = {
  compliance: ["reports", "compliance"] as const,
};

export const auditStatusConfigKeys = {
  all: ["audit-status-configs"] as const,
};

export const appSettingsKeys = {
  recipientTeams: ["app-settings", "recipient-teams"] as const,
  guidanceRequestTemplate: ["app-settings", "guidance-request-template"] as const,
};

export const statusReportKeys = {
  draft: ["status-report", "draft"] as const,
};

export const delyverKeys = {
  projects: ["delyver", "projects"] as const,
} as const;

export const techPartnerKeys = {
  all: ["tech-partners"] as const,
  productOptions: ["tech-partners", "product-options"] as const,
} as const;
